(function () {
  if (window.GSListingWishlistCartReady) return;
  window.GSListingWishlistCartReady = true;

  var WISHLIST_KEY = 'gs_wishlist_items';
  var LEGACY_KEYS = ['wishlist', 'gsWishlist', 'gs_wishlist', 'gse_wishlist', 'theme_wishlist', 'shopify_wishlist'];

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function safeParse(value) {
    if (!value) return [];

    try {
      var parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed;
      if (parsed && Array.isArray(parsed.items)) return parsed.items;
      if (parsed && Array.isArray(parsed.products)) return parsed.products;
    } catch (error) {
      return String(value).split(',').map(function (item) {
        return item.trim();
      }).filter(Boolean);
    }

    return [];
  }

  function normalizeItem(item) {
    if (!item) return null;

    if (typeof item === 'string' || typeof item === 'number') {
      var value = String(item).trim();
      if (!value) return null;
      return /^\d+$/.test(value) ? { id: value, key: value } : { handle: value, key: value };
    }

    var handle = String(item.handle || item.product_handle || item.productHandle || '').trim();
    var id = String(item.id || item.product_id || item.productId || '').trim();
    var key = handle || id;

    if (!key) return null;

    return {
      key: key,
      id: id,
      handle: handle,
      title: item.title || item.product_title || item.productTitle || '',
      url: item.url || (handle ? '/products/' + handle : ''),
      image: item.image || item.featured_image || item.featuredImage || '',
      price: item.price || item.price_text || item.priceText || '',
      variantId: item.variantId || item.variant_id || '',
      variantTitle: item.variantTitle || item.variant_title || ''
    };
  }

  function uniqueItems(items) {
    var seen = {};
    var clean = [];

    (items || []).forEach(function (item) {
      var normalized = normalizeItem(item);
      if (!normalized || !normalized.key || seen[normalized.key]) return;
      seen[normalized.key] = true;
      clean.push(normalized);
    });

    return clean;
  }

  function getWishlist() {
    var stored = localStorage.getItem(WISHLIST_KEY);

    if (stored) return uniqueItems(safeParse(stored));

    for (var i = 0; i < LEGACY_KEYS.length; i += 1) {
      var legacy = localStorage.getItem(LEGACY_KEYS[i]);
      if (legacy) return uniqueItems(safeParse(legacy));
    }

    return [];
  }

  function saveWishlist(items) {
    var clean = uniqueItems(items);
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(clean));
    updateWishlistButtons(clean);
    updateWishlistCounts(clean);

    document.dispatchEvent(new CustomEvent('wishlist:updated', {
      detail: {
        items: clean,
        count: clean.length
      }
    }));

    return clean;
  }

  function getProductFromButton(button) {
    var data = button.dataset || {};
    var card = button.closest('[data-gs-listing-card], .freshity-product-card, .grid__item, .card-wrapper') || button;
    var cardData = card.dataset || {};
    var link = card.querySelector && card.querySelector('a[href*="/products/"]');
    var image = card.querySelector && card.querySelector('img');
    var price = card.querySelector && card.querySelector('.freshity-card__price, .price, .price-item');
    var title = card.querySelector && card.querySelector('.freshity-card__title, .card__heading a, .full-unstyled-link, h3 a, h2 a');

    var url = data.productUrl || cardData.productUrl || (link ? link.getAttribute('href') : '');
    var handle = data.productHandle || cardData.productHandle || '';

    if (!handle && url && url.indexOf('/products/') !== -1) {
      handle = url.split('/products/')[1].split('?')[0].split('#')[0].replace(/\/$/, '');
    }

    return normalizeItem({
      id: data.productId || cardData.productId || '',
      handle: handle,
      title: data.productTitle || cardData.productTitle || (title ? title.textContent.trim() : ''),
      url: url || (handle ? '/products/' + handle : ''),
      image: data.productImage || cardData.productImage || (image ? image.currentSrc || image.src : ''),
      price: data.productPrice || cardData.productPrice || (price ? price.textContent.trim().replace(/\s+/g, ' ') : ''),
      variantId: data.variantId || cardData.variantId || '',
      variantTitle: data.variantTitle || cardData.variantTitle || ''
    });
  }

  function updateWishlistCounts(items) {
    var count = uniqueItems(items || getWishlist()).length;

    qsa('[data-gs-wishlist-count], [data-wishlist-count]').forEach(function (element) {
      element.textContent = count;
    });

    qsa('[data-gs-wishlist-count-bubble], [data-wishlist-count-bubble]').forEach(function (bubble) {
      if (count > 0) {
        bubble.removeAttribute('hidden');
      } else {
        bubble.setAttribute('hidden', 'hidden');
      }
    });
  }

  function updateWishlistButtons(items) {
    var keys = uniqueItems(items || getWishlist()).map(function (item) {
      return item.key;
    });

    qsa('[data-wishlist-toggle], [data-gse-wishlist-toggle]').forEach(function (button) {
      var item = getProductFromButton(button);
      if (!item) return;

      var active = keys.indexOf(item.key) !== -1;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function openWishlistDrawer() {
    var opener = document.querySelector('[data-gs-open-wishlist]');

    if (opener) {
      opener.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      return;
    }

    var drawer = document.querySelector('[data-gs-wishlist-drawer]');
    if (drawer) {
      drawer.classList.add('is-active');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('gs-drawer-open');
    }
  }

  function openCartDrawer() {
    var opener = document.querySelector('[data-gs-open-cart]');

    if (opener) {
      opener.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      return;
    }

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    var drawer = document.querySelector('[data-gs-cart-drawer]');
    if (drawer) {
      drawer.classList.add('is-active');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('gs-drawer-open');
    }
  }

  function addWishlist(button) {
    var item = getProductFromButton(button);
    if (!item) return;

    var current = getWishlist();
    var exists = current.some(function (existing) {
      return existing.key === item.key;
    });

    if (!exists) {
      current.push(item);
      saveWishlist(current);

      if (window.GSWishlist && typeof window.GSWishlist.refresh === 'function') {
        window.GSWishlist.refresh();
      }

      openWishlistDrawer();
    } else {
      saveWishlist(current.filter(function (existing) {
        return existing.key !== item.key;
      }));

      if (window.GSWishlist && typeof window.GSWishlist.refresh === 'function') {
        window.GSWishlist.refresh();
      }
    }
  }

  function addToCart(form) {
    var button = form.querySelector('[type="submit"], button[name="add"], .button, .freshity-btn');
    var formData = new FormData(form);

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok) throw json;
          return json;
        });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('gs:listing-cart-added'));
        openCartDrawer();
      })
      .catch(function (error) {
        alert((error && (error.description || error.message)) || 'Unable to add this product to cart.');
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
  }

  document.addEventListener('click', function (event) {
    var wishlistButton = event.target.closest('[data-wishlist-toggle], [data-gse-wishlist-toggle]');
    if (!wishlistButton || !wishlistButton.closest('[data-gs-listing-card], .freshity-product-card, .grid__item')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addWishlist(wishlistButton);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form || !form.closest('[data-gs-listing-card]')) return;

    // If the global GS cart drawer handler exists, let it own cart adds.
    if (window.GSCartWishlistDrawersReady) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addToCart(form);
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    updateWishlistButtons();
    updateWishlistCounts();

    if (window.GSWishlist && typeof window.GSWishlist.refresh === 'function') {
      window.GSWishlist.refresh();
    }
  });

  window.addEventListener('storage', function (event) {
    if (event.key === WISHLIST_KEY || LEGACY_KEYS.indexOf(event.key) !== -1) {
      updateWishlistButtons();
      updateWishlistCounts();
    }
  });

  document.addEventListener('wishlist:updated', function () {
    updateWishlistButtons();
    updateWishlistCounts();
  });
})();
